export const niveles = [
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'INICIAL',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Inicial.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'PRIMARIA',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Primaria.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'SECUNDARIA',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Secundaria.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'TECNICA',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Tecnica.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'SUPERIOR',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Superior.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'ESPECIAL',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Especial.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'GABINETE',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/Niveles/Gabinete.aspx',
      color: "#ffae55"
    }
  ]